<script>
import { BModal, BButton } from 'bootstrap-vue';
import MailModalForm from '../mail/ModalForm.vue';

export default {
  components: {
    BModal,
    BButton,
    MailModalForm,
  },

  props: [
    'user', 'root',
  ],

  data () {
    return {
      campaign: {
        name: null,
        manual: false,
      },
      type: 'auto',
      saving: false,
      created: {},
      mail: null,
      mails: [1],
      template: null,
      searching: false,
      errors: {},
    };
  },

  created () {
    Bus.$on('createAutomationButtonToggled', (reload) => {
      this.open();
    });
  },

  computed: {
    cards () {
      const cards = [
        {
          type: 'manual',
          title: 'Campanha Única',
          description: 'Envia uma única vez para seus leads.',
          icon: '<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H14C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V10C16 10.5304 15.7893 11.0391 15.4142 11.4142C15.0391 11.7893 14.5304 12 14 12H2C1.46957 12 0.960859 11.7893 0.585786 11.4142C0.210714 11.0391 0 10.5304 0 10V2ZM2 1C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V2.217L8 6.417L15 2.217V2C15 1.73478 14.8946 1.48043 14.7071 1.29289C14.5196 1.10536 14.2652 1 14 1H2ZM15 3.383L10.292 6.208L15 9.105V3.383ZM14.966 10.259L9.326 6.788L8 7.583L6.674 6.788L1.034 10.258C1.09083 10.4708 1.21632 10.6589 1.39099 10.7931C1.56566 10.9272 1.77975 11 2 11H14C14.2201 11 14.4341 10.9274 14.6088 10.7934C14.7834 10.6595 14.909 10.4716 14.966 10.259ZM1 9.105L5.708 6.208L1 3.383V9.105Z" fill="#242424"/></svg>',
        },
        {
          type: 'auto',
          title: 'Campanha Automatizada',
          description: 'Crie uma campanha para automatizar tarefas manuais de marketing.',
          icon: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.854 0.14615C15.9232 0.215482 15.9706 0.303624 15.9901 0.399627C16.0097 0.49563 16.0006 0.595263 15.964 0.68615L10.145 15.2331C10.0937 15.3613 10.0081 15.4727 9.89753 15.5553C9.78698 15.6379 9.65578 15.6884 9.51838 15.7012C9.38099 15.714 9.24272 15.6887 9.1188 15.628C8.99487 15.5673 8.89009 15.4736 8.816 15.3572L5.638 10.3622L0.643 7.18415C0.526318 7.11013 0.432352 7.00532 0.37147 6.88128C0.310588 6.75723 0.285158 6.61878 0.297985 6.4812C0.310812 6.34362 0.361398 6.21226 0.444161 6.10161C0.526924 5.99096 0.638647 5.90532 0.767 5.85415L15.314 0.0371498C15.4049 0.000562027 15.5045 -0.0085177 15.6005 0.0110385C15.6965 0.0305947 15.7847 0.0779249 15.854 0.14715V0.14615ZM6.636 10.0701L9.397 14.4081L14.13 2.57615L6.636 10.0701ZM13.423 1.86915L1.591 6.60215L5.93 9.36215L13.424 1.86915H13.423Z" fill="#242424"/></svg>',
        },
        {
          type: 'mkt',
          title: 'Campanha E-mail Marketing',
          description: 'Crie uma campanha de e-mail marketing.',
          icon: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.854 0.14615C15.9232 0.215482 15.9706 0.303624 15.9901 0.399627C16.0097 0.49563 16.0006 0.595263 15.964 0.68615L10.145 15.2331C10.0937 15.3613 10.0081 15.4727 9.89753 15.5553C9.78698 15.6379 9.65578 15.6884 9.51838 15.7012C9.38099 15.714 9.24272 15.6887 9.1188 15.628C8.99487 15.5673 8.89009 15.4736 8.816 15.3572L5.638 10.3622L0.643 7.18415C0.526318 7.11013 0.432352 7.00532 0.37147 6.88128C0.310588 6.75723 0.285158 6.61878 0.297985 6.4812C0.310812 6.34362 0.361398 6.21226 0.444161 6.10161C0.526924 5.99096 0.638647 5.90532 0.767 5.85415L15.314 0.0371498C15.4049 0.000562027 15.5045 -0.0085177 15.6005 0.0110385C15.6965 0.0305947 15.7847 0.0779249 15.854 0.14715V0.14615ZM6.636 10.0701L9.397 14.4081L14.13 2.57615L6.636 10.0701ZM13.423 1.86915L1.591 6.60215L5.93 9.36215L13.424 1.86915H13.423Z" fill="#242424"/></svg>',
        },
      ];

      if (this.root) {
        cards.push({
          type: 'templates',
          title: 'Templates de Campanhas Existentes',
          description: 'Selecione um template de campanha salvo.',
          icon: '<svg class="bdk-h-4 bdk-w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /> </svg>',
        });
      }

      return cards;
    },
  },

  methods: {
    async store (mailId = null) {
      this.saving = true;
      this.campaign.manual = this.type !== 'auto';

      try {
        const {
          data,
        } = await this.$http.post('/automation', this.campaign);

        if (mailId) {
          /**
             * Create default action.
             */
          await this.$http.post(`/automation/${data.id}/action`, {
            delay: 0,
            option: null,
            value: mailId,
            decision: null,
            parent_id: null,
            type: 'mail.send',
          });
        }

        return data;
      } catch (e) {
        throw e;
      }
    },

    async save () {
      const validateCampaignName = async () => {
        this.saving = true;
        try {
          await this.$http.get(`/automation/checkName?name=${this.campaign.name}`);
          this.saving = false;
          return true;
        } catch (error) {
          if (error.status === 422) {
            this.errors = error.body.name;
          } else {
            Alert.error(this.__('Erro ao validar o nome da campanha. Tente novamente.'));
          }
          this.saving = false;
          return false;
        }
      };

      if (this.type === 'mkt') {
        const isValidName = await validateCampaignName();
        if (!isValidName) {
          return;
        }

        this.close();
        this.openMail();

        return;
      }

      if (this.type === 'templates') {
        this.$http
          .post(`/automation/import/${this.template}`)
          .then(({ body: { message } }) => {
            this.close();
            Alert.info(message);
          });

        return;
      }

      try {
        const {
          id,
        } = await this.store();

        window.location = `/automation/${id}#/actions`;
      } catch (e) {
        if (e.status === 422) {
          this.errors = e.body.name;
          this.saving = false;
        } else if (e.status === 403) {
          return Alert.error(e.data.error);
        } else {
          Alert.error(this.__('Erro ao criar campanha. Tente novamente em instantes.'));
        }
      }
    },

    openMail () {
      this.$refs['modal-new-mail'].show();

      setTimeout(() => {
        document.querySelector('#mail-title').focus();
      }, 500);
    },

    async handleMail ({ id }, fresh = true) {
      try {
        const {
          id: automationId,
        } = await this.store(id);

        if (fresh) {
          window.open(`/mail/${id}/template`);
        }

        setTimeout(() => {
          window.location = `/automation/${automationId}#/actions`;
        }, 500);
      } catch (e) {
        if (e.status === 403) {
          return Alert.error(e.data.error);
        }
      }
    },

    closeMail () {
      this.$refs['modal-new-mail'].hide();
    },

    open () {
      this.$refs['create-automation-modal'].show();
    },

    close () {
      this.$refs['create-automation-modal'].hide();
    },

    searchMails (query = '') {
      if (query.length > 0 && query.length < 3) {
        return;
      }

      this.searching = true;

      this.$http.get(`/mail/search?query=${query}`)
        .then(({ data }) => {
          this.mails = data;
        })
        .finally(() => {
          this.searching = false;
        });
    },
  },

};
</script>

<template>
  <div
    class="automation-create"
  >
    <BModal
      size="lg"
      id="create-automation-modal"
      ref="create-automation-modal"
      modal-class="modal-purple-title"
    >
      <template
        slot="modal-header"
      >
        <div
          class="modal-title"
          v-text="__('Criar nova campanha')"
        />

        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="$refs['create-automation-modal'].hide()"
        >
          <span
            aria-hidden="true"
          >
            <img
              width="14"
              alt="Fechar"
              height="13"
              class="mb-5px"
              src="/build/icons/close@white.svg"
            >
          </span>
        </button>
      </template>

      <template
        slot="default"
      >
        <h2
          class="modal-subtitle text-center"
          v-text="__('Selecione o tipo de campanha que você quer criar')"
        />

        <p
          class="modal-text text-center"
          v-text="__('Você pode criar uma campanha única, de envio único ou uma campanha automatizada, que envia por usuário assim que um gatilho de evento é ativado.')"
        />

        <div
          class="form-automation"
        >
          <template
            v-if="type !== 'templates'"
          >
            <div
              class="form-group"
            >
              <label
                v-text="__('Nome da campanha')"
              />

              <input
                type="text"
                required=""
                autofocus=""
                id="autofocus"
                class="form-control"
                :class="{ 'is-invalid': errors[0] }"
                v-model="campaign.name"
                :placeholder="__('Digite aqui')"
              >

              <div v-if="errors[0]" class="invalid-feedback message-feedback">
                {{ errors[0] }}
              </div>
            </div>

            <div
              class="automation-type bdk-w-full bdk-flex bdk-flex-col"
            >
              <template
                v-for="card in cards"
              >
                <FormBuilderCard
                  v-bind="card"
                  @selected="type = $event"
                  :active="type === card.type"
                  :key="`automation-card-${card.type}`"
                />
              </template>
            </div>
          </template>

          <AutomationList
            v-else
            v-model="template"
          />
        </div>
      </template>

      <template
        slot="modal-footer"
      >
        <BButton
          variant="secundary"
          @click="type = 'auto'"
          v-if="type === 'templates'"
        >
          <span
            v-text="__('Voltar')"
          />
        </BButton>

        <BButton
          id="continue-button"
          type="submit"
          @click="save()"
          variant="primary"
          :disabled="type !== 'templates' && ! campaign.name"
        >
          <span
            v-text="__('Continuar')"
            v-if="! saving && type !== 'templates'"
          />

          <span
            v-else-if="! saving"
            v-text="__('Importar Template')"
          />

          <span
            v-else
          >
            <i
              class="fa fa-circle-o-notch fa-spin"
            />

            {{ __('Salvando...') }}
          </span>
        </BButton>
      </template>
    </BModal>

    <BModal
      id="modal-new-mail"
      ref="modal-new-mail"
      hide-footer="hide-footer"
      hide-header="hide-header"
      modal-class="modal-no-header-no-footer"
    >
      <template
        slot="default"
      >
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="closeMail"
        >
          <span
            aria-hidden="true"
          >
            ×
          </span>
        </button>

        <h4
          class="modal-title align-items-center text-center"
        >
          {{ __('Crie um novo e-mail') }}

          <h6
            class="modal-subtitle"
            v-text="__('Preencha os dados do e-mail')"
          />
        </h4>

        <MailModalForm
          :user="user"
          @saved="handleMail"
        />
      </template>
    </BModal>
  </div>
</template>

<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  #continue-button {
    padding: 12px 32px;
    background: $salesflow-secondary;
    border: 1px solid $salesflow-secondary;
    border-radius: 14px;
    color: $salesflow-font-dark;

    &:not(:disabled):hover {
      cursor: pointer;
      color: $white;
      background-color: $salesflow-secondary-hover;
    }
  }

  .automation-create {
    &__mails {
      ::v-deep .multiselect__option {
        padding: 6px 12px;
      }

      .multiselect__tags {
        span.multiselect__placeholder{
          width: 100%;
        }
      }

      input,
      select,
      .multiselect__placeholder {
        background-color: white;
        color: #4f4958;
      }
    }

    &__or {
      display: block;
      text-align: center;
      position: relative;
      margin-top: 16px;
      margin-bottom: -16px;

      &::after,
      &::before {
        top: 8px;
        width: 46%;
        content: '';
        position: absolute;
        border-bottom: 1px solid #e0dbe8;
      }

      &::before {
        left: 0;
      }

      &::after {
        right: 0;
      }
    }
  }

  .modal-purple-title {
    .modal-dialog {
      max-width: 866px !important;
    }

    .modal-content {
      background-color: $salesflow-bg-content;
      border-radius: 16px;
      overflow: hidden;

      .modal-body {
        padding: 32px 56px 24px;
        background-color: $salesflow-bg-content;

          .modal-subtitle {
            @include salesflow-subtitle($font-weight: 600, $color: $salesflow-font-dark);
          }

          .modal-text {
            @include salesflow-text();
            margin-bottom: 24px;
          }

          .form-automation {
            .form-group {
              label {
                @include salesflow-text();
              }
              margin-bottom: 8px;

              input {
                @include salesflow-subtitle($color: $salesflow-font-dark);
                padding: 13px 12px;
                background: $white;
                border: 1px solid $salesflow-outline-gray-medium;
                border-radius: 8px;

                &::placeholder {
                  color: $salesflow-font-gray;
                }
              }
              input:focus {
                border: 1px solid #86B7FE;
                border-color: #86B7FE !important;
                box-shadow: 0 0 0 0.25rem #0D6EFD40 !important;
              }
            }
          }

          .form-automation {
            .is-second {
              margin: 0 1rem;
            }

            & .automation-type {
              > .type-card {
                display: inline-block;
                flex-shrink: 0;
                flex: 1;
                padding: 33px;
                border: 1px solid transparent;
                box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
                border-radius: 15px;
                background-color: #f6f5f8;

                > .type-title {
                  margin-top: 15px;
                  color: #3b334a;
                  font-size: 16px;
                  font-weight: 700;
                  letter-spacing: -0.24px;
                  line-height: 25px;
                }

                > .type-description {
                  margin: 0;
                  color: #857a98;
                  font-size: 12px;
                  font-weight: 400;
                  letter-spacing: -0.18px;
                  line-height: 20px;
                }
              }

              & .selected {
                box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
                border-radius: 15px;
                border: 1px solid #edeaf0;
                background-color: #ffffff;
              }
            }
          }
        }
      }
    .modal-footer {
      background-color: $salesflow-bg-content;
      padding: 0px 120px 24px 120px;
    }
  }

  .is-invalid {
    border: 1px solid #dc3545 !important;
  }

  .message-feedback {
    color: #E14E4E;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
</style>
